module.exports = __webpack_public_path__ + "static/media/碩士推甄簡章_110.599131ba.pdf";